import { listType } from '@/api/receiptType'
export const getReceiptTypeMixins = {
  data() {
    return {
      receiptTypeLoading: false,
      receiptTypeList: [],
    }
  },
  mounted() {
    this.getReceiptTypeList()
  },
  methods: {
    async getReceiptTypeList() {
      this.receiptTypeLoading = true
      const { data: res } = await listType().catch(err => err)
      if (res) {
        this.receiptTypeList = res
      }
      this.receiptTypeLoading = false
    },
  },
}